import React, { useState, useCallback, useEffect } from "react";

import swal from "sweetalert";
import { Form, Input, FormField, FormGroup, Button } from "semantic-ui-react";

import AdminMenu from "../../../../components/Admin/MenuDetalhes/AdminMenu";
import Footer from "../../../../components/Footer";

import { producaov2 as api } from "../../../../services/apis";

import { Container, Box, Header, FormBlock, TableContainer } from "./styles";

import Table from "../../../../components/Table/templates/inscricoes";
import Controls from "../../../../components/Controls";
import Axios from "axios";

const RelatorioInscricoes = () => {
  document.title = "Painel Administrativo | Grupo Voitto";

  const [dataInicio, setDataInicio] = useState(new Date());
  const [dataFinal, setDataFinal] = useState(new Date());

  const [loadingPaidReport, setLoadingPaidReport] = useState(false);
  const [paidReport, setPaidReport] = useState('');

  const [loading, setLoading] = useState(false);
  const [relatorioExcel, setRelatorioExcel] = useState(false);
  const [relatorioCsv, setRelatorioCsv] = useState(false)

  const handleGenerateReport = useCallback(async () => {
    setLoading(true);
    setRelatorioExcel(false);
    setRelatorioCsv(false);

    const errorController = { error: false }

    await api.post("/admin/reports/inscricao",
      {
        data_inicio: dataInicio,
        data_final: dataFinal,
      }
    )
      .then((res) => {
        setRelatorioExcel(res.data.url);

        const acao = JSON.stringify({
          local: "Relatorio",
          texto: `Gerou o relatorio entre ${dataInicio} e ${dataFinal}}`,
        });

        api.post("system_logs", { acao });
      })
      .catch((error) => {
        errorController.error = true

        if (!error.response) {
          return;
        };

        swal(`Algo deu errado na geração do relatório em Excel`, `Se persistir, contate nosso suporte`, "error");
      });


    await api.post("/admin/reports/inscricao-csv",
      {
        data_inicio: dataInicio,
        data_final: dataFinal,
      },
    )
      .then((res) => {
        setRelatorioCsv(res.data.url);
        const acao = JSON.stringify({
          local: "Relatorio",
          texto: `Gerou o relatorio em CSV entre ${dataInicio} e ${dataFinal}}`,
        });

        api.post("system_logs", { acao });
      })
      .catch((error) => {
        errorController.error = true
        if (!error.response) {
          return;
        };

        swal(`Algo deu errado na geração do relatório em CSV`, `Se persistir, contate nosso suporte`, "error");
      });

    setLoading(false);

    if (!errorController.error) {
      swal("Confirmado!", "Relatórios gerados com sucesso", "success");
    };

  }, [dataInicio, dataFinal, swal]);

  const handleGeneratePaidReport = useCallback(() => {
    setLoadingPaidReport(true);
    setPaidReport('');

    api
      .post("/admin/reports/inscricao-pagas", {
        data_inicio: dataInicio,
        data_final: dataFinal,
      })
      .then((res) => {
        setPaidReport(res.data.url);

        const acao = JSON.stringify({
          local: "Relatorio",
          texto: `Gerou o relatorio entre ${dataInicio} e ${dataFinal}}`,
        });

        api.post("system_logs", { acao });
        swal("Confirmado!", "Relatório gerado com sucesso", "success");
      })
      .catch((error) => {
        if (!error.response) {
          return;
        }

        swal(`Algo deu errado`, `Se persistir, contate nosso suporte`, "error");
      })
      .finally(() => {
        setLoadingPaidReport(false);
      });
  }, [dataInicio, dataFinal]);

  return (
    <div style={{width: "100vw", paddingLeft:"250px", marginBottom:"2rem", border:"none"}}>

      <AdminMenu />
      <Container>
        <Header>Relatório Inscrições</Header>
        <Box>
          <Form>
            <FormBlock>
              <p>Selecionar período</p>
              <FormField>
                A partir de
                <Input
                  onChange={(e) => setDataInicio(e.target.value)}
                  type="date"
                />
                até
                <Input
                  onChange={(e) => setDataFinal(e.target.value)}
                  type="date"
                />
              </FormField>
            </FormBlock>

            <FormGroup>
              {(!relatorioExcel && !relatorioCsv) && (
                <Button
                  color="orange"
                  onClick={handleGenerateReport}
                  loading={loading}
                >
                  Gerar Relatório Inscrições
                </Button>
              )}
              <>
              {relatorioExcel && (
                  <Button
                    style={{ minWidth: "80px" }}
                    as="a"
                    href={relatorioExcel}
                    target="_blank"
                    onClick={() => setRelatorioExcel(null)}
                    color="green"
                  >
                    Baixar Relatório Inscrições - Excel
                  </Button>
              )}
                {relatorioCsv && (
                  <Button
                    style={{ minWidth: "80px" }}
                    as="a"
                    href={relatorioCsv}
                    target="_blank"
                    onClick={() => setRelatorioCsv(null)}
                    color="green"
                  >
                    Baixar Relatório Inscricoes - CSV
                  </Button>
                )}
              </>
              {paidReport ? (
                <Button
                  color="green"
                  basic
                  info="Inscrições Pagas"
                  title="Inscrições Pagas"
                  as="a"
                  href={paidReport}
                  target="_blank"
                  onClick={() => setPaidReport(null)}
                >
                  Baixar Relatório Inscrições Pagas
                </Button>
              ) : (
                <Button
                  color="blue"
                  basic
                  info="Inscrições Pagas"
                  title="Inscrições Pagas"
                  loading={loadingPaidReport}
                  onClick={handleGeneratePaidReport}
                >
                  Gerar Relatório Inscrições Pagas
                </Button>
              )}
            </FormGroup>
          </Form>
        </Box>
      </Container>
    </div>
  );
};

export default RelatorioInscricoes;
